import React from 'react';

const EditProfile = props => {
  return (
    <div
      className="container-edit-profile"
    >
		<div className="profile-entry">
			<label className="profile-entry-label">
				{props.language.user_profile.detail.editData + ":"}
			</label>
			<div className="profile-entry-value">
		      <button
		        data-close="ok"
              	onClick={props.handleModalPass}
		        className="normal_button"
		      >		        
		        {props.language.user_profile.detail.resetPassword}
		      </button>				
			</div>
		</div>
		<div className="profile-entry">
			<label className="profile-entry-label">
				{props.language.user_profile.detail.linkToWearable + ":"}
			</label>
			<div className="profile-entry-value">
		      <button
		        onClick={props.datos.isAuthenticated ? 
					props.handleClickDisconnectFitbit : 
					props.handleClickConnectFitbit}
		        className="normal_button"
		      >		        
		        {props.datos.isAuthenticated ? 
					props.language.user_profile.detail.unLinkToFitbit : 
					props.language.user_profile.detail.linkToFitbit}
		      </button>							
			</div>
		</div>
		<div className="profile-entry">
			<label className="profile-entry-label">
				{props.language.user_profile.detail.tours + ":"}
			</label>
			<div className="profile-entry-value">
		      <button
		        onClick={props.handleClickResetTours}
		        className="normal_button"
		      >		        
		        {props.language.user_profile.detail.resetTours}
		      </button>							
			</div>
		</div>
    </div>
  );
};
export default EditProfile;



// WEBPACK FOOTER //
// ./source/client/components/user_profile/editProfile.jsx